<template>
  <div style="border: 1px solid #ccc">
    <!-- <b-button @click="saveData">Guardar</b-button> -->
    <div class="table-title">
      <h3 class="titulo-c3">Cuadro 5</h3>
      <h3 class="titulo-c3">{{ title }}</h3>
    </div>
    <table class="table">
      <thead>
        <tr>
          <th scope="col">Proyectos / Categorías</th>
          <th scope="col">Presupuesto Final </th>
          <th scope="col">Ejecución</th>
          <th scope="col">Saldo No Ejecutado</th>
          <th scope="col">Notas</th>
          <th scope="col">
            <b-button class="button-add" @click="addItemListEight">+</b-button>
          </th>
        </tr>
      </thead>
      <tbody>
        <Row
          v-for="(item, index) in itemList"
          :key="index"
          :removeItem="removeItem"
          :objTest="item"
          :anio="anio"
          :perc="perc"
          :difference="difference"
          :itemList="itemList"
        />
      </tbody>
    </table>
  </div>
</template>

<script>
import Row from "./Row.vue";
export default {
  props:["addItemListEight", "itemList", "removeItem"],
  components: {
    Row,
  },
  data() {
    return {
      title: `Comportamiento Presupuestario de las Inversiones año ${process.env.VUE_APP_ANIO}`,
      anio: parseInt(process.env.VUE_APP_ANIO),
    };
  },

  methods: {
    difference: function(itemList) {
      const number =
        parseInt(itemList.pptoFinalAnio) - parseInt(itemList.ejecucionAnio);

      const toReturn = (isNaN(number) ? 0 : number).toString();

      return toReturn;
    },
    perc: function(itemList) {
      const number =
        (parseInt(itemList.ejecucionAcumulada) * 100) / parseInt(itemList.costoTotal);
      const toReturn = (isNaN(number) ? 0 : number).toString();

      return toReturn;
    },

 
  },
};
</script>

<style scoped>
.titulo-c3 {
  font-size: 1.1rem;
  color: #2b425f;
  font-weight: bold;
  margin: 0;
  text-align: center;
}
.table > tbody,
.table > thead {
  vertical-align: middle;
}
.button-add {
  background: #25a2b7 !important;
  color: white !important;
  border: none;
  width: 25px;
  height: 25px;
  border-radius: 14px;
  padding: 0 !important;
  font-size: 1.5rem;
  font-weight: bold;
  line-height: 0;
}

.table-title{
background: #EFEFEF;
}
</style>
